<template>
  <div>
    <div class="base-lockup base-lockup--dark search__inner-full">
      <p class="base-lockup__copy">You searched for "{{ keyword }}"</p>
      <p class="base-lockup__copy">
        Viewing results "{{ resultsStart }}-{{ resultsEnd }} out of
        {{ results.length }}"
      </p>
    </div>

    <div v-if="results" class="search__inner-full">
      <div
        v-for="i in resultsEnd - resultsStart + 1"
        :key="i"
        class="base-lockup base-lockup--dark search__result"
      >
        <h3
          class="base-lockup__heading base-lockup__heading--4 search__result-title"
        >
          {{ getResult(i - 1).title }}
        </h3>
        <p class="base-lockup__copy base-lockup__copy--regular">
          {{ getResult(i - 1).description }}
        </p>
        <p class="base-lockup__copy base-lockup__copy--regular">
          <a :href="getResult(i - 1).link" class="search__result-link">
            {{ getResult(i - 1).link }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params: Object,
      keyword: '',
      pageNum: 1,
      resultsStart: 1,
      resultsEnd: 10,
      resultsTotal: Number,
    }
  },
  props: {
    results: {
      type: Array,
    },
  },
  methods: {
    getResult(i) {
      let num = this.resultsStart + i - 1
      return this.results[num]
    },
  },
  mounted() {
    this.params = new URLSearchParams(window.location.search.substring(1))
    if (this.params.get('q')) {
      this.keyword = this.params.get('q')
    } else {
      this.keyword = this.params.get('as_q')
    }

    // get the result starting, ending numbers
    if (this.params.get('page')) {
      this.pageNum = this.params.get('page')
      this.pageNum = Number(this.pageNum)
    }
    if (this.pageNum == 1) {
      this.resultsStart = 1
      this.resultsEnd = 10
    } else {
      this.resultsStart = (this.pageNum - 1) * 10 + 1
      this.resultsEnd = this.pageNum * 10
    }
    if (this.resultsEnd > this.results.length) {
      this.resultsEnd = this.results.length
    }
  },
}
</script>
